<template>
    <div class="has-tooltip relative">
        <slot />
        <span class="tooltip-icon mdi-information-outline" @mouseover="showTooltip = true" @mouseout="showTooltip = false"></span>
        <div
            id="tooltip-text"
            v-show="showTooltip"
            class="tooltip hidden"
        >
            {{ text }}
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    props: ['text'],
    data() {
        return {
            showTooltip: false,
        };
    },
})
export default class Tooltip extends Vue {
    name = 'tooltip';
}

Vue.component('tooltip', Tooltip);
</script>
